<template>
    <transition
        enter-active-class="ease-out duration-200"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div class="w-full h-full absolute top-0" v-if="isLoading">
            <div
                class="w-full h-full bg-gray-300 dark:bg-gray-500 flex justify-center items-center text-gray-800"
            >
                <element-loading-spinner class="w-8 h-8"/>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        isLoading: {
            type: Boolean,
            required: true,
        },
    },
};
</script>
